// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiFamily {
    static getAttributeTypeMap() {
        return MedicalBiFamily.attributeTypeMap;
    }
}
MedicalBiFamily.discriminator = undefined;
MedicalBiFamily.additionalProperties = false;
MedicalBiFamily.attributeTypeMap = [
    {
        "name": "deductibleMet",
        "baseName": "deductibleMet",
        "type": "number"
    },
    {
        "name": "deductibleTotal",
        "baseName": "deductibleTotal",
        "type": "number"
    },
    {
        "name": "oopMax",
        "baseName": "oopMax",
        "type": "number"
    },
    {
        "name": "oopMet",
        "baseName": "oopMet",
        "type": "number"
    },
];
//# sourceMappingURL=medicalBiFamily.js.map